import React, { type PropsWithChildren, useRef } from 'react';
import { ApplicationView as view } from '@aha-app/mvc';
import { useDrop } from 'react-dnd';
import type DraggableItem from '../DraggableItem';
import { sharedDragController } from '../controllers/DragController';

type ContainerDropTargetProps = {
  accept: string | string[];
  className?: string;
};

/**
 * The ContainerDropTarget is used to wrap other drop targets or item lists. Whenever the drag is dropped
 * over this drop target, then the drop is completed with the most recent drop handler and drag items.
 * This allows a drag to finish on a container that isn't itself directly a drop target, but is a container
 * around other valid drop targets.
 */
const ContainerDropTarget: React.FC<
  PropsWithChildren<ContainerDropTargetProps>
> = ({ accept, children, className = null }) => {
  const ref = useRef(null);

  const [, drop] = useDrop({
    accept,
    canDrop(draggedItem: DraggableItem, monitor) {
      return true;
    },
    drop(draggedItem: DraggableItem, monitor) {
      if (!monitor.didDrop()) {
        sharedDragController.actionFinishDrop();
      }
    },
  });

  drop(ref);

  return (
    <div className={className ?? undefined} ref={ref}>
      {children}
    </div>
  );
};

export default view(ContainerDropTarget);
